export default {"src":"/_next/static/image/public/images/Green_circle.7a84d3762dd265d64d72706bb30e2b2d.svg","height":16,"width":16};